
import React from 'react';
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import { clsx } from 'clsx';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: '#174A84',
    },
}));

const ControlledCard = props => {
    const {
        title = "",
        summary = "",
        hideAllActions = false,
        hideExpandAction = false,
        hideButtonAction = false,
        avatarSrc = null,
        avatarText = "",
        onButtonClick = fn => fn,
    } = props;
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Card className={classes.root} variant="outlined">
            <CardHeader
                avatar={
                    <Avatar src={avatarSrc} aria-label="recipe" className={classes.avatar}>
                        {avatarText}
                    </Avatar>
                }
                style={{ textAlign: 'left', paddingBottom: 0 }}
                title={title}
            />
            {!hideAllActions &&
                <CardActions disableSpacing>

                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        size="large">
                        {!hideExpandAction && <ExpandMoreIcon />}
                    </IconButton>
                    {!hideButtonAction &&
                        <Button onClick={() => onButtonClick()} style={{ textTransform: 'capitalize' }} size="small" color="primary">
                            Learn More
                        </Button>
                    }
                </CardActions>
            }
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <Typography paragraph>
                        {summary}
                    </Typography>
                </CardContent>
            </Collapse>
        </Card>
    );
}

ControlledCard.propTypes = {
    title: PropTypes.string,
    hideAllActions: PropTypes.bool,
    hideExpandAction: PropTypes.bool,
    hideButtonAction: PropTypes.bool,
    avatarSrc: PropTypes.any,
    avatarText: PropTypes.string,
    summary: PropTypes.string,
    onButtonClick: PropTypes.func,
};

export default ControlledCard;